/** VUEX module for app management */
import i18n from '@/i18n/i18n';

export default {
  namespaced: true,
  state: {
    // initial state
    togleTutor: false,
    processing: false,
    fullscreen: false,
    language: i18n.locale,
    dialogLessonSearchVisible: false,
    sidebar: {
      isCollapsed: localStorage.getItem('sidebarStatus') ? !!+localStorage.getItem('sidebarStatus') : true,
      position: 'left',
    },
    currentQuery:'',
  },
  getters: {
    // getters
    togleTutor:state => state.togleTutor,
    processing: state => state.processing,
    sidebar: state => state.sidebar,
    fullscreen: state => state.fullscreen,
    language: state => state.language,
    dialogLessonSearchVisible: state => state.dialogLessonSearchVisible,
    getCurrentQuery: state => {
      return state.currentQuery;
    },
  },
  mutations: {
    TOGGLE_DIALOG_LESSON_SEARCH_VISIBLE: state => {
      state.dialogLessonSearchVisible = !state.dialogLessonSearchVisible;
    },
    SET_LANGUAGE: (state, lang) => {
      state.language = lang;
      i18n.locale = lang;
    },
    SET_POSITION_IN_SIDEBAR: (state, position) => {
      state.sidebar.position = position;
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.isCollapsed = !state.sidebar.isCollapsed;
      if (state.sidebar.isCollapsed) {
        localStorage.setItem('sidebarStatus', 1);
      } else {
        localStorage.setItem('sidebarStatus', 0);
      }
    },
    TOGGLE_FULLSCREEN: state => {
      state.fullscreen = !state.fullscreen;
    },
    // mutations
    START_PROCESSING(state) {
      state.processing = true;
    },
    STOP_PROCESSING(state) {
      state.processing = false;
    },
    SET_CURRENT_QUERY: (state, query) => {
      state.currentQuery = query ;
    },
    TOGGLE_TUTOR: state => {
      state.togleTutor = !state.togleTutor;
    },
  },
  actions: {
    // actions
    TOGGLE_SIDEBAR({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
    TOGGLE_FULLSCREEN({ commit }) {
      commit('TOGGLE_FULLSCREEN');
    },
    TOGGLE_TUTOR({ commit }) {
      commit('TOGGLE_TUTOR');
    },
  },
};
